import axios from 'axios'
import { ApiConfig } from '../../config/api'
import { templateMassiveProcessPackingList } from '../../const/templatesFileName'

export const getPackingListTemplate = () => {
  const url = new URL(
    `${ApiConfig.ProcessApi}/GetTemplateFile/${templateMassiveProcessPackingList}`
  )
  return axios.get(url.toString())
}

export const postPackingList = (dto: FormData) => {
  const url = new URL(`${ApiConfig.ProcessApi}/PackingListUploadFile`)

  const headers = {
    'Content-Type': 'multipart/form-data'
  }

  return axios.post(url.toString(), dto, { headers })
}
